/*
 * File: cell-action-download.ts
 * Created: 2026-01-22
 * Author: Val Liu
 */

import { Component, Watch } from "vue-property-decorator";
import CellActionBase from "@root/components/table/elements/body/cell-action/base/cell-action-base";

@Component
export default class CellActionDownload extends CellActionBase {
    get defaultLabel(): string {
        return this.label ?? "w_TranslationJobDownload";
    }

    @Watch("row", { immediate: true, deep: true })
    handleRowChange() {
        const visible = String(this.row?.status ?? "").toUpperCase() === "COMPLETED";
        this.setVisible(visible);
    }

    get isDisabled() {
        const outputFile = this.row?.outputFile as any;
        const fileId =
            outputFile?.id ?? (typeof outputFile === "string" ? outputFile : null);
        return !fileId;
    }

    handleClick(event: Event) {
        const outputFile = this.row?.outputFile as any;
        const fileId =
            outputFile?.id ?? (typeof outputFile === "string" ? outputFile : null);
        if (!fileId) {
            event.preventDefault();
            return;
        }
        const baseUrl = this.$server.UrlFile();
        const authHeaders = this.$server.applyAccessToken?.() ?? {};
        const auth = (authHeaders as Record<string, string>)["Authorization"] ?? "";
        const token = auth.replace(/^Bearer\\s+/i, "");
        const url =
            `${baseUrl}id=${encodeURIComponent(String(fileId))}` +
            (token ? `&token=${encodeURIComponent(token)}` : "");
        window.location.href = url;
    }
}
